module.exports = __webpack_public_path__ + "static/students-splash-05f376791b5bf0c3997b8fcd782a0996.jpg";